<template>
  <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import Store from '@/store'
import axios from 'axios'
import VueCookies from 'vue-cookies'

Vue.prototype.$loginUser = async function (loginInfo) {
  try {
    const response = await axios.post('/auth/authorize', loginInfo)
    sessionStorage.setItem('login', loginInfo.login)
    sessionStorage.setItem('account', loginInfo.account)

    localStorage.setItem('partner_id_int', response.data.partner_id_int)

    Store.commit('LOGIN_USER')
    Store.commit('PASSWORD_CHANGE_REQUIRED', response.data.isbackdoor ? false : response.data.password_change_requested)
    Store.commit('IS_INTERNAL_STAFF', response.data.isInternalStaff)
    Store.commit('IS_RUSTY_ACCOUNT', response.data.isRustyAccount)

    if (response.data.kioskMode === false && response.data.role === 'User') {
      Store.commit('ROLE_SETUP', 'Admin')
    } else {
      Store.commit('ROLE_SETUP', response.data.role)
    }
    Store.commit('KIOSK_MODE', response.data.kioskMode)

    if (response.data.user_id !== undefined) {
      Store.commit('ROLE_SETUP', Store.state.currentRole)
      Store.commit('SUBSCRIPTIONS_SETUP', response.data.subscriptions)
    }

    try {
      const aResponse = await axios.post('/api/academy/getacademy', {}, {
        headers: {
          Authorization: `Bearer ${response.data.token}`
        }
      })
      const d = aResponse.data
      let isVidible = (d.AcademyVisible + '').toLowerCase()
      if (isVidible === 'y' || isVidible === 'yes' || isVidible === 'true' || isVidible === '1') {
        isVidible = true
      } else {
        isVidible = false
      }
      let data = {
        show: isVidible,
        token: d.AcademyToken,
        url: d.AcademyUrl
      }
      Store.commit('SET_ACADEMY', data)
    } catch (err) {
      let data = {
        show: false,
        token: undefined,
        url: undefined
      }
      Store.commit('SET_ACADEMY', data)
    }

    return undefined
  } catch (error) {
    return error
  }
}

Vue.use(VueCookies)

export default {
  name: 'app',
  created: function () {

  }
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
</style>
<style>
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue